import { request } from 'api/request';
import { EmailDeliveryResponse } from 'api/types';

export const loadEmailDelivery = async (actionId: string) => {
  const response = await request.get<EmailDeliveryResponse>(`v1/emails/delivery/${actionId}/`);
  return response.data;
};
